<section class="flex-column h-100 mr-md-3 mt-5">
    <div class="row mx-0">
        <div class="col-6">
            <canvas class="myChart" [id]="chartId"></canvas>
        </div>
        <div class="col-6 pt-5 pl-5">
            <div class="d-flex mb-1">
                <span [style.background]="colors[0]" class="point my-auto mr-2"></span>
                <p class="mb-0 chart-info">{{yValues[0]}} : <span style="font-weight: 500;">{{xValues[0]}} videos</span>
                </p>
            </div>
            <div class="d-flex mb-1">
                <span [style.background]="colors[1]" class="point my-auto mr-2"></span>
                <p class="mb-0 chart-info">{{yValues[1]}} : <span style="font-weight: 500;">{{xValues[1]}} videos</span>
                </p>
            </div>
            <div class="d-flex mb-1">
                <span [style.background]="colors[2]" class="point my-auto mr-2"></span>
                <p class="mb-0 chart-info">{{yValues[2]}} : <span style="font-weight: 500;">{{xValues[2]}} videos</span>
                </p>
            </div>
        </div>

    </div>
</section>